/**
 * Check glyph used to confirm a completed action — the success toast's
 * leading mark and the copy button's transient "copied" state. Uses
 * `currentColor` so the enclosing surface controls tinting.
 *
 * The artwork is authored on a 16x16 grid, so callers wanting the
 * design's native scale pass `size={16}`.
 */
export type CheckGlyphProps = {
  /** Rendered width/height in px. Defaults to 24. */
  size?: number;
  className?: string;
};

function CheckGlyph({ size = 24, className }: CheckGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="m13.333 4.5-7 7-3.166-3.166"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CheckGlyph;
